import { IMasterclass, getDeliverableQuestionVariable } from '@shared';
import {
  DELIVERABLE_PROMPT_INTRO_PREFIX,
  DELIVERABLE_PROMPT_LABEL_TRAILING_PUNCTUATION,
  DELIVERABLE_PROMPT_SLIDE_PREFIX,
  DELIVERABLE_PROMPT_SLIDE_SEPARATOR,
  DELIVERABLE_PROMPT_TITLE_PREFIX
} from '../back-office-conf';

export interface IDeliverableQuestionVariable {
  variable: string;
  question: string;
  courseLabel: string;
}

export interface IDeliverableQuestionVariableGroup {
  moduleLabel: string;
  variables: IDeliverableQuestionVariable[];
}

export const listDeliverableQuestionVariables = (masterclass: IMasterclass): IDeliverableQuestionVariableGroup[] => {
  const groups: IDeliverableQuestionVariableGroup[] = [];
  masterclass?.modules?.forEach((module) => {
    const variables: IDeliverableQuestionVariable[] = [];
    module.chapters?.forEach((chapter) =>
      chapter.courses?.forEach((course) =>
        course.deliverableQuestions?.forEach((question) =>
          variables.push({
            variable: getDeliverableQuestionVariable(question.id),
            question: question.question,
            courseLabel: `${chapter.name} > ${course.name}`
          })
        )
      )
    );
    if (variables.length) {
      groups.push({ moduleLabel: module.name, variables });
    }
  });
  return groups;
};

export const formatDeliverableQuestionVariablesAsList = (groups: IDeliverableQuestionVariableGroup[]): string =>
  groups
    .map((group) => group.variables.map((variable) => variable.variable).join('\n'))
    .join('\n');

export const formatDeliverableQuestionVariablesAsPrompt = (
  masterclassName: string,
  groups: IDeliverableQuestionVariableGroup[]
): string => {
  const slides = groups.map((group, index) =>
    [
      `${DELIVERABLE_PROMPT_SLIDE_PREFIX} ${index + 1} - ${group.moduleLabel.toUpperCase()}`,
      `${DELIVERABLE_PROMPT_TITLE_PREFIX} "${group.moduleLabel}"`,
      ...group.variables.map((variable) => `- ${toPromptLabel(variable.question)} : ${variable.variable}`)
    ].join('\n')
  );
  const intro = `${DELIVERABLE_PROMPT_INTRO_PREFIX} "${masterclassName}".`;
  return [intro, slides.join(`\n\n${DELIVERABLE_PROMPT_SLIDE_SEPARATOR}\n\n`)].join('\n\n');
};

const toPromptLabel = (question: string): string => question.trim().replace(DELIVERABLE_PROMPT_LABEL_TRAILING_PUNCTUATION, '');
